/* eslint-disable react/prop-types */

import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';

function NoOptionsMessage(props) {
    return (
        <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            fullWidth
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.formControlProps}
        />
    );
}

class Option extends Component {
    shouldComponentUpdate(nextProps) {
        const { value } = this.props;

        return nextProps.value !== value;
    }

    render() {
        const props = this.props;

        return (
            <MenuItem
                buttonRef={props.innerRef}
                selected={props.isFocused}
                key={props.value}
                style={{
                    fontWeight: props.isSelected ? 500 : 400,
                }}
                component="div"
                {...props.innerProps}
            >
                {props.children}
            </MenuItem>
        );
    }
}

function Placeholder(props) {
    return (
        <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function SingleValue(props) {
    return (
        <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function ValueContainer(props) {
    return (
        <div name={props.selectProps.name} className={props.selectProps.classes.valueContainer}>
            {props.children}
        </div>
    );
}

function MultiValue(props) {
    return (
        <Chip
            tabIndex={-1}
            label={props.children}
            className={classNames(props.selectProps.classes.chip, {
                [props.selectProps.classes.chipFocused]: props.isFocused,
            })}
            onDelete={ props.removeProps.onClick }
            deleteIcon={ <CancelIcon {...props.removeProps} /> }
        />
    );
}

function Menu(props) {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
}

const components = {
    Control,
    Menu,
    MultiValue,
    NoOptionsMessage,
    Option,
    Placeholder,
    SingleValue,
    ValueContainer,
};

import selectStyle from './styles.jsx';

@withStyles(selectStyle, { withTheme: true })
export default class ReactSelect extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
    };

    static defaultProps = {
        filterable: false,
    };

    state = {
        isLoaded: false
    };

    componentDidMount(){
        this.preLoadList();
    }

    componentDidUpdate(){
        this.preLoadList();
    }

    /**
     * Pre load data if needed
     */
    preLoadList(){
        const { options, filterable } = this.props;
        const { isLoaded } =  this.state;

        if (!isLoaded && !filterable && !options.length) {
            this.handleInputChange('', {action: 'input-change'});
            this.setState({isLoaded: true});
        }
    }

    /**
     * Transform value to simple
     */
    getValue = () => {
        const { value, options } = this.props;

        if (Array.isArray(value)) {
            return options.filter(option => value.indexOf(option.value) !== -1);
        }

        return options.find(option => option.value === value);
    };

    /**
     * Simple value
     *
     * @param value
     * @param action
     */
    handleChange = (value, { action }) => {
        const { onChange, customChange } = this.props;

        if (onChange) {
            switch (action) {
                case 'select-option':
                case 'remove-value':
                    if (Array.isArray(value)) {
                        onChange(value.map(item => item.value));
                        customChange ? customChange(value.map(item => item.value)) : {};
                    } else {
                        onChange(value.value);
                        customChange ? customChange(value.value) : {};
                    }
                    break;
                case 'pop-value':
                    onChange(null);
                    customChange ? customChange(null) : {};
                    break;
                default:
                    onChange(value);
                    customChange ? customChange(value) : {};
            }
        }
    };

    /**
     * Simple value
     *
     * @param inputValue
     * @param action
     */
    handleInputChange = (inputValue, { action }) => {
        const { onInputChange } = this.props;

        if (onInputChange) {
            switch (action) {
                case 'input-change':
                    onInputChange(inputValue);
            }
        }
    };

    /**
     * Fix for autocomplete and redux form on mobile devices
     * Without this fix on all mob and some desktop devices value doesn`t send to redux after select
     * @param event
     * @returns {*}
     */
    handleBlur = event => event.preventDefault();

    /**
     * On/Off default filter handler
     *
     * @returns {*}
     */
    getFilterProps = () => {
        const { filterable } = this.props;

        return filterable ? {} : { filterOption: options => options };
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { classes, theme, ...SelectProps } = this.props;

        const selectStyles = {
            input: base => ({
                ...base,
                color: theme.palette.text.primary,
            }),
        };

        return (
            <Select
                className='custom-autocomplete-select'
                classes={classes}
                styles={selectStyles}
                components={components}
                onBlurResetsInput={false}
                {...this.getFilterProps()}
                {...SelectProps}
                onInputChange={this.handleInputChange}
                onChange={this.handleChange}
                value={this.getValue()}
                onBlur={this.handleBlur}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/CustomAutocomplete/CustomAutocomplete.jsx